import { useOpenBrandVoiceModal } from 'screens/BrandKits/components/BrandVoice/useOpenBrandVoiceModal'
import { HighDetailedVoice } from 'blaze-ui/icons/24'
import { FirstBrandAICard } from 'screens/BrandKits/components/NewBrandAICard/FirstBrandAICard'
import { NewBrandAICard } from 'screens/BrandKits/components/NewBrandAICard/NewBrandAICard'
import { BrandCardSize } from '../../BrandAICard/Types'
import { useTierUsageLimits } from 'hooks/useTierUsageLimits'
import { observer } from 'mobx-react-lite'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { useModals } from 'almanac-ui/Modal'
import { TierUpgradeModal } from 'components/TierUpgradeModal/TierUpgradeModal'

interface Props {
  size?: BrandCardSize
  title?: string
}

export const NewBrandVoiceCard = observer(({ size = 'sm', title = 'New Brand Voice' }: Props) => {
  const openAddVoiceModal = useOpenBrandVoiceModal()
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({ limitKey: 'brand_kits' })
  const { openModal } = useModals()

  return (
    <NewBrandAICard
      upgradeBadge={atLimit && nextTierPlan ? <PricePill plan={nextTierPlan.key} /> : null}
      title={title}
      size={size}
      onPress={() => {
        atLimit && nextTierPlan && currentTierPlan
          ? openModal(TierUpgradeModal, {
              reason: 'limit_reached',
              feature: 'Brand Voices',
              upgradeTier: nextTierPlan,
              currentTier: currentTierPlan,
              onUpgrade: openAddVoiceModal,
            })
          : openAddVoiceModal()
      }}
    />
  )
})

export const FirstBrandVoiceCard = () => {
  const openAddVoiceModal = useOpenBrandVoiceModal()

  return <FirstBrandAICard title="New Brand Voice" icon={HighDetailedVoice} onPress={() => openAddVoiceModal()} />
}
